import { useEffect } from "react";

const AdminMain = () => {
  useEffect(() => {}, [])
  return (
    <>
      <h2>통계 페이지</h2>
    </>
  );
};

export default AdminMain;
